






















import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import LearningGroupTableItem from "@/components/learning-group/LearningGroupTableItem.vue";
import { LearningGroup as ILearningGroup } from "@/api-v2/learning-group/models/learning-group";

@Component({ components: { LearningGroupTableItem, CustomTable } })
export default class LearningGroupTable extends Vue {
  @Prop() groups!: ILearningGroup[];
  @Prop() isLoading!: boolean;
}
